import React, {useCallback} from "react";
import PropTypes from "prop-types";

const UIForm = React.forwardRef(({preventDefault, onSubmit, ...props}, ref) => {
  const formOnSubmit = useCallback((e) => {
    if (preventDefault) {
      e.preventDefault();
    }

    onSubmit && onSubmit(e);
  }, [onSubmit, preventDefault]);

  return (
    <form
      ref={ref}
      onSubmit={formOnSubmit}
      {...props}
    />
  )
});


UIForm.propTypes = {
  preventDefault: PropTypes.bool,
  method: PropTypes.string,
  onSubmit: PropTypes.func,
};

UIForm.defaultProps = {
  method: 'POST',
};

export default UIForm;
